import type { ApiClient } from './client.js';
import type { ClassroomSettingsDto, ScheduleItemDto } from './types.js';

export interface UpdateClassroomSettingsBody {
  greeting?: string;
  message?: string;
  lastSelectedDay?: number | null;
  zipCode?: string;
  schoolCalUrl?: string;
  schoolCalTitle?: string;
  questionShowDaily?: boolean;
  questionShowWeekly?: boolean;
  questionDaily?: string;
  questionWeekly?: string;
  questionDailyAnswer?: string;
  questionWeeklyAnswer?: string;
  numberDrawingEnabled?: boolean;
  homeVariant?: 'k3' | 'g48';
}

export interface CreateScheduleItemBody {
  text: string;
  days: number[];
}

export interface HomeApi {
  getSettings(classroomId: string): Promise<ClassroomSettingsDto>;
  patchSettings(
    classroomId: string,
    body: UpdateClassroomSettingsBody,
  ): Promise<ClassroomSettingsDto>;
  listSchedule(classroomId: string): Promise<ScheduleItemDto[]>;
  createScheduleItem(classroomId: string, body: CreateScheduleItemBody): Promise<ScheduleItemDto>;
  removeScheduleItem(classroomId: string, itemId: string): Promise<void>;
}

export function createHomeApi(client: ApiClient): HomeApi {
  return {
    async getSettings(classroomId) {
      const res = await client.get<{ settings: ClassroomSettingsDto }>(
        `/api/classrooms/${classroomId}/settings`,
      );
      return res.settings;
    },
    async patchSettings(classroomId, body) {
      const res = await client.patch<{ settings: ClassroomSettingsDto }>(
        `/api/classrooms/${classroomId}/settings`,
        body,
      );
      return res.settings;
    },
    async listSchedule(classroomId) {
      const res = await client.get<{ schedule: ScheduleItemDto[] }>(
        `/api/classrooms/${classroomId}/schedule`,
      );
      return res.schedule;
    },
    async createScheduleItem(classroomId, body) {
      const res = await client.post<{ item: ScheduleItemDto }>(
        `/api/classrooms/${classroomId}/schedule`,
        body,
      );
      return res.item;
    },
    async removeScheduleItem(classroomId, itemId) {
      await client.delete(`/api/classrooms/${classroomId}/schedule/${itemId}`);
    },
  };
}
